import InsightsContentLoader from './InsightsContentLoader'

export default InsightsContentLoader
